import React from 'react'
import {useNavigate} from 'react-router-dom'


const Singlegadget = ({data}) => {
 const navigate = useNavigate()

  return (
    <>
    <div key={data.id} id='singlegadget-image-con'>
  <div id='singlegadget-image'>
<img id='level' src={`asset/${data.image}`} alt="" />
<div  id='price-off'>
<h6>56<br/>%</h6>
</div>
  </div>

<div id='singlegadget-text-con'>
<h6>{data.name}</h6>
<p>${data.price}</p>
<h5 onClick={()=>navigate(`/Product/${data.id}`)} >View Now</h5>
</div>
</div>
    
 
    </>
  )
}

export default Singlegadget